import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { browserHistory } from 'react-router';

import ActionMenu from 'components/action-menu';
import Price from 'components/price';

export default class Block extends React.Component {

  /* Handlers */

  blockHandler(e) {
    e.stopPropagation();

    const { item, linkTo, onClick } = this.props;

    if (linkTo) browserHistory.push(linkTo);
    if (onClick) onClick(item);
  }

  /* Render */

  render() {
    return (
      <div className="block__content" onClick={(e) => { this.blockHandler(e); }} role="button">
        {this.renderLabel()}
        {this.renderActionMenu()}

        {/* image */}
        <img className="block__schema u-center" src={this.props.schema} alt="Schema" title={this.props.title} />

        {/* info */}
        <div className="block__info">
          <div className="block__info__row">
            <div className="block__info__cell">
              <span className="block__title">{this.props.title}</span>
            </div>
          </div>
          <div className="block__info__row">
            <div className="block__info__cell u-margin-top-xs u-margin-bottom-xs">
              <span className="block__subtitle">{this.props.subtitle}</span>
            </div>
            <div className="block__info__cell">
              <span className="block__subtitle block__subtitle--nowrap">{this.props.number}</span>
            </div>
          </div>
          <div className="block__info__row">
            {this.renderPrice()}
          </div>
        </div>
      </div>
    );
  }

  renderActionMenu() {
    const { actions, actionHandler } = this.props;

    if (actions && actions.length && actionHandler) {
      return (
        <div className="block__button">
          <ActionMenu actions={actions} actionHandler={actionHandler}>
            <span className="icon icon--xxs icon-dots" />
          </ActionMenu>
        </div>
      );
    }

    return null;
  }

  renderLabel() {
    const { status } = this.props;

    if (status) {
      return (
        <div className={`block__status label label--status-${status}`}>
          <FormattedMessage id={`general.status.${status}`} />
        </div>
      );
    }

    return null;
  }

  renderPrice() {
    const { price } = this.props;

    return (
      <div className="block__info__cell">
        <span className="block__title">
          <Price minimal value={price} vatExcluded />
        </span>
      </div>
    );
  }
}

Block.propTypes = {
  actionHandler: PropTypes.func,
  actions: PropTypes.array,
  item: PropTypes.object,
  linkTo: PropTypes.string,
  number: PropTypes.string,
  onClick: PropTypes.func,
  price: PropTypes.number,
  subtitle: PropTypes.string,
  schema: PropTypes.string,
  status: PropTypes.string,
  title: PropTypes.string,
};



// WEBPACK FOOTER //
// ./js/components/block/index.jsx